import "./SalaryDetails.css";
import { lazy, useCallback, useEffect, useState, useRef, useMemo } from "react";
import ButtonCom from "../../../components/button/button";
import { Form, Row, Col } from "react-bootstrap";
import {
  getPayrollModelListPath,
  calculatePayrollPath,
  calculateEarnedSalaryPath,
  savePayrollEmployeePath,
  getForm22Path,
} from "../../../services/config";
import { useDispatch, useSelector } from "react-redux";
import {
  commonGetData,
  commonGetDataOne,
  commonSaveData,
  commonSaveDataOne,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import {
  initSalaryState,
  saveUpdateSalary,
} from "../../../redux/slices/salarySlice";
import { getPayrollModuleList } from "../../../redux/slices/payrollSlice";

// ✅ REMOVED: import { ToastContainer, toast } from "react-toastify";
// ✅ ADDED: use global toast instead
import { useGlobalToast } from "../../../stopOldToastGlobally"; 

import Switch from "@mui/material/Switch";
import { AgGridReact } from "ag-grid-react";

import { PDFDownloadLink } from "@react-pdf/renderer";
import WageSlip from "../../../components/PDF/WageSlip";
import SalarySlip from "../../../components/PDF/SalarySlip";

import { BiMessageSquareDetail } from "react-icons/bi";
import { CiUser } from "react-icons/ci";
import { RiEdit2Line } from "react-icons/ri";
import { MdCastForEducation } from "react-icons/md";
import { CgFileDocument } from "react-icons/cg";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { BsBank } from "react-icons/bs";
import { FiPlus } from "react-icons/fi";

import CheckImg from "../../../assets/Images/check.png";

import {
  getCapitalizeWord,
  downloadPdf,
  base64Conversion,
  convertToBase64,
} from "../../../services/commonServices";

import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import WidgetsButton from "../../../components/Widgets/button";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { HasPermission } from "../../../services/hasPermission";
import { isNull } from "lodash";

const SalaryDetails = ({ userDetails, commonState }) => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const dispatch = useDispatch();
  const toast = useGlobalToast(); // ✅ Use global toast hook

  const commonStore = useSelector((state) => state.common);
  const payrollListStore = useSelector((state) => state.payroll);
  const salaryStore = useSelector((state) => state.salary);
  const [salaryDetails, setSalaryDetails] = useState(null);
  const [attendanceDbList, setAttendanceDbList] = useState([]);
  const [companyState, setCompanyState] = useState({});

  const [state, setState] = useState({
    payrollList: [],
    month: "",
    payrollModelId: "",
    payrollType: "monthly",
    grossPayAmount: "",
    grossMonthlyOrYearly: "0",
    data: {},
    dearnessName: "",
    dearnessMonthlyAmount: "",
    dearnessYearlyAmount: "",
    bankAccountNumber: userDetails[0]?.bankDetails?.bankAccountNumber,
    bankName: userDetails[0]?.bankDetails?.bankName,
  });

  const contentRef = useRef();
  const [errorMessage, setErrorMessage] = useState("");
  const [earningAllowance, setEarningAllowance] = useState([]);
  const [newAllowance, setNewAllowance] = useState([]);
  const [maxMonth, setMaxMonth] = useState("");

  const getCompanyRecords = useCallback(() => {
    const path = getForm22Path + user.user_id;
    dispatch(commonGetData(path));
  });

  const [logoBase64, setLogoBase64] = useState(null);

  useEffect(() => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    setMaxMonth(`${year}-${month}`);

    let d = userDetails[0].salaryDetails?.payrollMonthYear?.split("-");
    let dd = d ? `${d[0]}-${d[1]}` : null;

    setState((prev) => ({
      ...prev,
      month: dd ? dd : `${year}-${month}`,
    }));
    setSalaryDetails(userDetails[0].salaryDetails.payrollMonthYear);

    if (dd != null) {
      const dt = userDetails[0].salaryDetails.payrollMonthYear.split("-");
      setState((pre) => ({
        ...pre,
        month: dt[0] + "-" + dt[1],
        grossPayAmount: userDetails[0].salaryDetails.grossAmount,
        payrollModelId: userDetails[0].salaryDetails.payrollModelId,
        payrollType: userDetails[0].salaryDetails.payrollType,
        grossMonthlyOrYearly: userDetails[0].salaryDetails.grossMonthlyOrYearly,
      }));

      const data = {
        path: calculatePayrollPath,
        data: {
          userId: user.user_id,
          staffId: userDetails[0].staffId,
          payrollModelId: userDetails[0].salaryDetails.payrollModelId,
          grossPayAmount: userDetails[0].salaryDetails.grossAmount,
          grossMonthlyOrYearly: userDetails[0].salaryDetails.grossMonthlyOrYearly,
          payrollType: userDetails[0].salaryDetails.payrollType,
          payrollDate: userDetails[0].salaryDetails.payrollMonthYear,
        },
      };
      dispatch(commonSaveData(data));

      const dataOne = {
        path: calculateEarnedSalaryPath,
        data: {
          userId: user.user_id,
          staffId: userDetails[0].staffId,
          payrollModelId: userDetails[0].salaryDetails.payrollModelId,
          grossPayAmount: userDetails[0].salaryDetails.grossAmount,
          grossMonthlyOrYearly: userDetails[0].salaryDetails.grossMonthlyOrYearly,
          payrollType: userDetails[0].salaryDetails.payrollType,
          payrollDate: userDetails[0].salaryDetails.payrollMonthYear,
        },
      };
      dispatch(commonSaveDataOne(dataOne));
    }
  }, []);

  const getPayrollList = useCallback(() => {
    const path = getPayrollModelListPath + user.user_id;
    dispatch(getPayrollModuleList(path));
  }, []);

  useState(() => {
    getPayrollList();
  }, []);

  const handleMonth = (e) => {
    setState((pre) => ({ ...pre, month: e.target.value, data: {} }));
    const data = {
      path: calculatePayrollPath,
      data: {
        userId: user.user_id,
        staffId: userDetails[0].staffId,
        payrollModelId: state.payrollModelId,
        grossPayAmount: state.grossPayAmount,
        grossMonthlyOrYearly: state.grossMonthlyOrYearly,
        payrollType: state.payrollType,
        payrollDate: e.target.value,
      },
    };
    dispatch(commonSaveData(data));
  };

  const handleSalaryType = (e) => {
    setState((pre) => ({ ...pre, payrollType: e.target.value, data: {} }));
    if (state.grossPayAmount && state.payrollModelId) {
      const data = {
        path: calculatePayrollPath,
        data: {
          userId: user.user_id,
          staffId: userDetails[0].staffId,
          payrollModelId: state.payrollModelId,
          grossPayAmount: state.grossPayAmount,
          grossMonthlyOrYearly: state.grossMonthlyOrYearly,
          payrollType: e.target.value,
          payrollDate: state.month,
        },
      };
      dispatch(commonSaveData(data));
      setErrorMessage("");
    } else {
      setErrorMessage(
        `Please select ${!state.payrollModelId ? "Salary Structure" : ""} 
        ${!state.payrollModelId && !state.ctc ? "and" : ""} 
        ${!state.ctc ? " gross amount" : ""} first to proceed`
      );
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const handleSalaryStructure = (e) => {
    setState((pre) => ({ ...pre, payrollModelId: e.target.value, data: {} }));
    if (state.grossPayAmount && state.payrollType) {
      const data = {
        path: calculatePayrollPath,
        data: {
          userId: user.user_id,
          staffId: userDetails[0].staffId,
          payrollModelId: e.target.value,
          grossPayAmount: state.grossPayAmount,
          grossMonthlyOrYearly: state.grossMonthlyOrYearly,
          payrollType: state.payrollType,
          payrollDate: state.month,
        },
      };
      setErrorMessage("");
      dispatch(commonSaveData(data));
    } else {
      setErrorMessage(
        `Please select ${!state.payrollType ? "Salary Type" : ""}  
        ${!state.payrollType && !state.ctc ? "and" : ""} 
        ${!state.ctc ? " CTC" : ""} first to proceed`
      );
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const handleGrossPayAmount = (e) => {
    setState((pre) => ({ ...pre, grossPayAmount: e.target.value, data: {} }));
    if (e.target.value.length > 3) {
      if (state.payrollModelId && state.payrollType) {
        const data = {
          path: calculatePayrollPath,
          data: {
            userId: user.user_id,
            staffId: userDetails[0].staffId,
            payrollModelId: state.payrollModelId,
            grossPayAmount: e.target.value,
            grossMonthlyOrYearly: state.grossMonthlyOrYearly,
            payrollType: state.payrollType,
            payrollDate: state.month,
          },
        };
        setErrorMessage("");
        dispatch(commonSaveData(data));
      } else {
        setErrorMessage(
          `Please select ${!state.payrollType ? "Salary Type" : ""} 
          ${!state.payrollModelId && !state.payrollType ? "and" : ""} 
          ${!state.payrollModelId ? " Salary Structure" : ""} first to proceed`
        );
        setTimeout(() => setErrorMessage(""), 3000);
      }
    }
  };

  const handleGrossMonthlyOrYearlyChange = (e) => {
    setState((pre) => ({ ...pre, grossMonthlyOrYearly: e.target.value, data: {} }));
    if (state.payrollModelId && state.payrollType) {
      const data = {
        path: calculatePayrollPath,
        data: {
          userId: user.user_id,
          staffId: userDetails[0].staffId,
          payrollModelId: state.payrollModelId,
          grossPayAmount: state.grossPayAmount,
          grossMonthlyOrYearly: e.target.value,
          payrollType: state.payrollType,
          payrollDate: state.month,
        },
      };
      setErrorMessage("");
      dispatch(commonSaveData(data));
    } else {
      setErrorMessage(
        `Please select ${!state.payrollType ? "Salary Type" : ""} 
        ${!state.payrollModelId && !state.payrollType ? "and" : ""} 
        ${!state.payrollModelId ? " Salary Structure" : ""} first to proceed`
      );
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const [earnedSalary, setEarnedSalary] = useState([]);
  const [companyDetails, setCompanyDetails] = useState({});

  useEffect(() => {
    if (payrollListStore.payrollModListSuccess) {
      setState((pre) => ({
        ...pre,
        payrollList: payrollListStore.payrollModListData || [],
      }));
    }

    if (commonStore.commonGetSuccess) {
      setCompanyState(commonStore.commonGetData);
      dispatch(initCommonState()); // ✅ Reset so no auto toast triggers
    }

    if (commonStore.commonGetError) {
      setCompanyState({});
      dispatch(initCommonState()); // ✅ Reset on error too
    }

    if (commonStore.commonSuccessOne) {
      setEarnedSalary(commonStore.commonDataOne);
    }

    if (commonStore.commonSuccess) {
      setState((pre) => ({ ...pre, data: commonStore.commonData }));

      setTimeout(() => {
        getCompanyRecords();
      }, 1000);

      setErrorMessage("");

      const earningsArray =
        commonStore.commonData?.salaryOutput.allowanceList?.filter(
          (item) =>
            item.name != "Other Allowance" && item.name != "Dearness Allowance"
        );
      const dearnessArray =
        commonStore.commonData?.salaryOutput.allowanceList?.filter(
          (item) => item.name == "Dearness Allowance"
        );
      setEarningAllowance(earningsArray || []);

      if (dearnessArray.length > 0) {
        setState((pre) => ({
          ...pre,
          dearnessName: dearnessArray[0].name,
          dearnessMonthlyAmount: dearnessArray[0].monthlyAmount,
          dearnessYearlyAmount: dearnessArray[0].yearlyAmount,
        }));
      }

      setNewAllowance(commonStore.commonData?.salaryOutput?.newAllowanceList || []);
      dispatch(initCommonState());
    }

    if (commonStore.commonError) {
      setErrorMessage(commonStore.commonMessage);
      setTimeout(() => setErrorMessage(""), 5000);
      setState((pre) => ({ ...pre, data: {} }));
      dispatch(initCommonState());
    }

    // ✅ Only show toast when user clicks Save/Update button
    if (salaryStore.salarySuccess) {
      toast.success("Salary details updated successfully!"); // ✅ Shows modal toast
      dispatch(initSalaryState());
    }

    if (salaryStore.salaryError) {
      toast.error(salaryStore.salaryMessage || "Failed to update salary details."); // ✅ Shows modal toast
      dispatch(initSalaryState());
    }
  }, [dispatch, commonStore, payrollListStore, salaryStore]);

  useEffect(() => {
    if (
      (state.data.salaryOutput != undefined &&
        earnedSalary.month != undefined &&
        companyState.contractorName != undefined) ||
      (state.data.salaryOutput != undefined && earnedSalary.month != undefined)
    ) {
      const slipData = [
        {
          month: state.month,
          amount: state.data?.salaryOutput?.netSalary,
          extra: 1200,
          deduction: 500,
          paid: 1200,
          paymentDate: state.month,
          transaction_id: "-",
          status: 1,
          paySlip:
            state.data && earnedSalary ? (
              <SalarySlip
                mainData={state.data?.salaryOutput}
                userDetails={userDetails}
                month={state.month}
                companyDetails={companyState}
                earnedSalary={earnedSalary}
                logo={user.company_logo}
                companyName={user.company_name}
              />
            ) : null,
          fileName: "Salary Slip",
        },
        {
          month: state.month,
          amount: 333,
          extra: 1200,
          deduction: 500,
          paid: 1200,
          paymentDate: state.month,
          transaction_id: "-",
          status: 1,
          paySlip:
            state.data && earnedSalary ? (
              <WageSlip
                mainData={state.data}
                userDetails={userDetails}
                month={state.month}
                companyDetails={companyState}
                earnedSalary={earnedSalary}
              />
            ) : null,
          fileName: "Wage Slip",
        },
      ];
      setAttendanceDbList(slipData);
    }
  }, [earnedSalary, state.data, companyState]);

  const [earnings, setEarnings] = useState([
    { id: "basic1", head: "Basic", calculation: "basic", amount: 0 },
    { id: "hra1", head: "HRA", calculation: "hra", amount: 0 },
    { id: "dearness1", head: "Dearness Allowance", calculation: "dearness", amount: 0 },
  ]);

  const addEarningField = (e) => {
    const { value, label } = e;
    setEarnings([...earnings, { id: value, head: label, calculation: "", amount: 0 }]);
  };

  const removeEarningFields = (e, index) => {
    e.preventDefault();
    const rows = [...earnings];
    rows.splice(index, 1);
    setEarnings(rows);
  };

  const handleEarningChanges = (index, e) => {
    const { name, value } = e.target;
    const list = [...earnings];
    list[index][name] = value;
    setEarnings(list);
  };

  const [deductions, setDeductions] = useState([]);

  const addDeductionsField = (e) => {
    const { value, label } = e;
    setDeductions([...deductions, { id: value, head: label, calculation: "", amount: 0 }]);
  };

  const removeDeductionsFields = (e, index) => {
    e.preventDefault();
    const rows = [...deductions];
    rows.splice(index, 1);
    setDeductions(rows);
  };

  const handleDeductionsChanges = (index, e) => {
    const { name, value } = e.target;
    const list = [...deductions];
    list[index][name] = value;
    setDeductions(list);
  };

  // ✅ Only dispatches — toast fires in useEffect on salaryStore.salarySuccess
  const savePayrollEmployee = () => {
    if (Object.keys(state.data).length) {
      const data = {
        path: savePayrollEmployeePath,
        data: {
          userId: user.user_id,
          staffId: userDetails[0].staffId,
          payrollModelId: state.payrollModelId,
          grossAmount: state.grossPayAmount,
          grossMonthlyOrYearly: state.grossMonthlyOrYearly,
          payrollType: state.payrollType,
          payrollDate: `${state.month}-01`,
          netSalary: state.data?.salaryOutput?.netSalary,
          ctcAmount: state.data?.salaryOutput.costToCompany,
        },
      };
      dispatch(saveUpdateSalary(data)); // ✅ No toast here
    } else {
      toast.error("Please select salary detail first"); // ✅ Shows modal toast
    }
  };

  const downloadFile = async (e) => {
    e.preventDefault();
    const table = contentRef.current;
    const doc = new jsPDF();
    doc.text("Salary Details", 14, 10);
    autoTable(doc, {
      html: table,
      startY: 20,
      theme: "grid",
      headStyles: { fillColor: [0, 100, 0] },
      styles: { fontSize: 10 },
      margin: { left: 20, right: 20 },
      didParseCell: function (data) {
        if (typeof data.cell.raw === "string") {
          const centerAlignedRows = [
            "Employee Contributions (B)",
            "Employer Contributions (C)",
          ];
          if (centerAlignedRows.includes(data.cell.raw.trim())) {
            data.cell.styles.halign = "center";
          }
        }
      },
    });
    doc.save("SalaryDetails.pdf");
  };

  const handleDateChange = (e) => {
    console.log(e.target.value);
  };

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  const columns = useMemo(
    () => [
      {
        headerName: "Month",
        cellRenderer: (rowData) => rowData.data.month,
        pinned: "left",
        width: "100px",
      },
      {
        headerName: "Salary Amount",
        cellRenderer: (rowData) => <span>{rowData.data.amount}</span>,
        width: "120px",
      },
      {
        headerName: "Extra",
        cellRenderer: (rowData) => <span>{rowData.data.extra}</span>,
        width: "100px",
      },
      { headerName: "Deduction", field: "deduction", width: "100px" },
      { headerName: "Paid Amount", field: "paid", width: "100px" },
      { headerName: "Payment Date", field: "paymentDate", width: "100px" },
      { headerName: "Transaction ID", field: "transaction_id", width: "180px" },
      { headerName: "Status", field: "status", width: "100px" },
      {
        headerName: "Pay Slip",
        width: "180px",
        pinned: "right",
        cellRenderer: (rowData) => (
          <PDFDownloadLink
            document={rowData.data.paySlip}
            fileName={`${rowData.data.fileName}_${rowData.data.month}.pdf`}
            style={{
              textDecoration: "none",
              padding: "8px",
              color: "#883ffdff",
              backgroundColor: "transparent",
              borderRadius: 4,
              width: "170px",
            }}
          >
            {({ loading }) =>
              loading ? "Generating PDF..." : `Download ${rowData.data.fileName}`
            }
          </PDFDownloadLink>
        ),
      },
    ],
    []
  );

  const downloadBothPDF = () => {
    downloadPdf(
      <SalarySlip
        mainData={state.data?.salaryOutput}
        userDetails={userDetails}
        month={state.month}
        companyDetails={companyState}
        earnedSalary={earnedSalary}
        logo={user.company_logo}
        companyName={user.company_name}
      />,
      `SalarySlip_${state.month}`
    );
    downloadPdf(
      <WageSlip
        mainData={state.data?.salaryOutput}
        userDetails={userDetails}
        month={state.month}
        companyDetails={companyState}
        earnedSalary={earnedSalary}
      />,
      `WageSlip_${state.month}`
    );
  };

  return (
    <div className="salary-details-container">
      <div className="mb-3">
        <Widgets
          icon={<WidgetsIcon icon={<CgFileDocument />} title="Current Salary Summary" />}
          body={
            <Row>
              <Col sm="6">
                <div className="uni-flex-space-between">
                  <span className="color-gray">CTC Yearly</span>
                  <span className="color-white">
                    &#8377;{" "}
                    {parseFloat(state.data?.salaryOutput?.costToCompany).toFixed(2)}
                  </span>
                </div>
              </Col>
              <Col sm="6">
                <div className="uni-flex-space-between">
                  <span className="color-gray">Monthly Gross Salary</span>
                  <span className="color-white">
                    &#8377; {parseFloat(state.grossPayAmount).toFixed(2)}
                  </span>
                </div>
              </Col>
              <Col sm="6">
                <div className="uni-flex-space-between">
                  <span className="color-gray">Net Pay</span>
                  <span className="color-white">
                    &#8377;{" "}
                    {parseFloat(state.data?.salaryOutput?.netSalary).toFixed(2)}
                  </span>
                </div>
              </Col>
              <Col sm="6">
                <div className="uni-flex-space-between">
                  <span className="color-gray">Pay Cycle</span>
                  <span className="color-white">
                    {getCapitalizeWord(state.payrollType)}
                  </span>
                </div>
              </Col>
              <Col sm="6">
                <div className="uni-flex-space-between">
                  <span className="color-gray">Payment Mode</span>
                  <span className="color-white">Bank Transfer</span>
                </div>
              </Col>
              <Col sm="6">
                <div className="uni-flex-space-between">
                  <span className="color-gray">Bank A/C Number</span>
                  <span className="color-white">
                    ****{state.bankAccountNumber.slice(-8)}({state.bankName})
                  </span>
                </div>
              </Col>
            </Row>
          }
        />
      </div>

      <div className="mb-3">
        <Widgets
          icon={<WidgetsIcon icon={<CgFileDocument />} title="Current Salary Summary" />}
          button={
            HasPermission("Salary details", "edit") && (
              <WidgetsButton
                type="button"
                text="Update Details"
                icon={<RiEdit2Line className="btn-icon" />}
                onClick={savePayrollEmployee}
              />
            )
          }
          body={
            <Form className="mt-4">
              <div className="page-body">
                <Row>
                  <Col sm="3">
                    <Form.Group>
                      <Form.Label className="color-gray">Effective Month of Change</Form.Label>
                      <Form.Control
                        type="month"
                        name="month"
                        max={maxMonth}
                        value={state.month}
                        onChange={handleMonth}
                        className="universal-input"
                      />
                    </Form.Group>
                  </Col>
                  <Col sm="2">
                    <Form.Group>
                      <Form.Label className="color-gray">Salary Type</Form.Label>
                      <Form.Select
                        name="payrollType"
                        value={state.payrollType}
                        onChange={handleSalaryType}
                        className="universal-input"
                        style={{ color: "white" }}
                      >
                        <option value="">Select Salary Type</option>
                        <option value="monthly">Per Month</option>
                        <option value="weekly">Per Week</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col sm="3">
                    <Form.Group>
                      <Form.Label className="color-gray">Salary Structure</Form.Label>
                      <Form.Select
                        name="payrollModelId"
                        value={state.payrollModelId}
                        onChange={handleSalaryStructure}
                        className="universal-input"
                        style={{ color: "white" }}
                      >
                        <option value="">Select Salary Structure</option>
                        {state.payrollList?.map((val, idx) => (
                          <option value={val.payrollModelId} key={idx}>
                            {val.payrollModelName}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col sm="2">
                    <Form.Group>
                      <Form.Label className="color-gray">Gross Amount</Form.Label>
                      <Form.Control
                        type="number"
                        name="grossPayAmount"
                        value={state.grossPayAmount}
                        onChange={handleGrossPayAmount}
                        placeholder="0"
                        className="universal-input"
                        style={{ color: "white" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm="2">
                    <Form.Group>
                      <Form.Label className="color-gray">Type</Form.Label>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Form.Select
                          name="grossMonthlyOrYearly"
                          value={state.grossMonthlyOrYearly}
                          onChange={handleSalaryStructure}
                          className="universal-input"
                          style={{ color: "white" }}
                        >
                          <option value="">Select Salary Structure</option>
                          <option value="1">Yearly</option>
                          <option value="0">Monthly</option>
                        </Form.Select>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-2">
                  <Col sm="8"></Col>
                  <Col sm="4">
                    {state.data?.salaryOutput?.netSalary && (
                      <Form.Group
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          gap: "10px",
                        }}
                      >
                        <div>
                          <Form.Label className="color-gray">Net Salary</Form.Label>
                          <Form.Control
                            type="number"
                            value={state.data?.salaryOutput.netSalary}
                            placeholder="0"
                            readOnly
                            className="universal-input"
                          />
                        </div>
                        <div>
                          <Form.Label className="color-gray">CTC</Form.Label>
                          <Form.Control
                            type="number"
                            value={state.data?.salaryOutput.costToCompany}
                            placeholder="0"
                            readOnly
                            className="universal-input"
                          />
                        </div>
                      </Form.Group>
                    )}
                  </Col>
                </Row>
              </div>

              <div
                className="universal-bg-color mt-3"
                style={{ padding: "10px", borderRadius: "12px" }}
              >
                <div
                  className="page-body mt-3"
                  style={{ height: state.data?.grossPayAmount ? "100%" : "57dvh" }}
                >
                  {state.data?.grossPayAmount ? (
                    <Row>
                      <Col sm="4">
                        <h4 className="mb-2">Employer Contribution - A</h4>
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th style={{ textAlign: "right" }}>Month</th>
                              <th style={{ textAlign: "right" }}>Annum</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>BASIC</td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.basicPay).toFixed()}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.basicPayYearly).toFixed(2)}
                              </td>
                            </tr>
                            {state.dearnessName && (
                              <tr>
                                <td>{state.dearnessName}</td>
                                <td style={{ textAlign: "right" }}>
                                  {parseFloat(state.dearnessMonthlyAmount).toFixed(2)}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {parseFloat(state.dearnessYearlyAmount).toFixed(2)}
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td>HRA</td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.hraPay).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.hraPayYearly).toFixed(2)}
                              </td>
                            </tr>
                            {earningAllowance?.map((val, idx) => (
                              <tr key={idx}>
                                <td>{val.name}</td>
                                <td style={{ textAlign: "right" }}>
                                  {parseFloat(val.monthlyAmount).toFixed(2)}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {parseFloat(val.yearlyAmount).toFixed(2)}
                                </td>
                              </tr>
                            ))}
                            <tr>
                              <td>Other Allowance</td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.otherAllowances).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.otherAllowancesYearly).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td><strong>Gross Salary (A)</strong></td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.grossSalary).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.grossSalaryYearly).toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </Col>

                      <Col sm="4">
                        <h4 className="mb-2">Employee Contribution - B</h4>
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th style={{ textAlign: "right" }}>Month</th>
                              <th style={{ textAlign: "right" }}>Annum</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{state.data?.salaryOutput.employeePFText}</td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.employeePf).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.employeePfYearly).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>ESI (0.75% on Gross)</td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.employeeEsi).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.employeeEsiYearly).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>Professional Tax</td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.professionalTax).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.professionalTaxYearly).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>LWF</td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.lwfAmount).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>{"0.00"}</td>
                            </tr>
                            <tr>
                              <td><strong>Total Deduction</strong></td>
                              <td style={{ textAlign: "right" }}>
                                {(
                                  parseFloat(state.data?.salaryOutput.employeePf) +
                                  parseFloat(state.data?.salaryOutput.employeeEsi) +
                                  parseFloat(state.data?.salaryOutput.lwfAmount) +
                                  parseFloat(state.data?.salaryOutput.professionalTax)
                                ).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {(
                                  parseFloat(state.data?.salaryOutput.employeePfYearly) +
                                  parseFloat(state.data?.salaryOutput.employeeEsiYearly) +
                                  parseFloat(state.data?.salaryOutput.lwfAmountYearly) +
                                  parseFloat(state.data?.salaryOutput.professionalTaxYearly)
                                ).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td><strong>Net Salary</strong></td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.netSalary).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.netSalaryYearly).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td><strong>Total Employee Contribution</strong></td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.totalEmployeeContributions).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.totalEmployeeContributionsYearly).toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </Col>

                      <Col sm="4">
                        <h4 className="mb-2">Employer Contribution - C</h4>
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th style={{ textAlign: "right" }}>Month</th>
                              <th style={{ textAlign: "right" }}>Annum</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                PF (
                                {state.data?.salaryOutput.employerEdli > 0 ||
                                state.data?.salaryOutput.adminCharges > 0
                                  ? "13%"
                                  : "12%"}
                                on Basic
                                {state.data?.salaryOutput.employerEdli > 0 && " + EDLI"}
                                {state.data?.salaryOutput.adminCharges > 0 && " + Admin Charges"}
                                )
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {(
                                  parseFloat(state.data?.salaryOutput.employerPf) +
                                  parseFloat(state.data?.salaryOutput.employerEdli) +
                                  parseFloat(state.data?.salaryOutput.adminCharges)
                                ).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {(
                                  parseFloat(state.data?.salaryOutput.employerPfYearly) +
                                  parseFloat(state.data?.salaryOutput.employerEdliYearly) +
                                  parseFloat(state.data?.salaryOutput.adminChargesYearly)
                                ).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>ESI (3.25% on Gross)</td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.employerEsi).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.employerEsiYearly).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td>LWF</td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.employerLwfAmount).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.employerLwfAmountYearly).toFixed(2)}
                              </td>
                            </tr>
                            {newAllowance?.map((val, idx) => (
                              <tr key={idx}>
                                <td>{val.name}</td>
                                <td style={{ textAlign: "right" }}>
                                  {parseFloat(val.monthlyAmount).toFixed(2)}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {parseFloat(val.yearlyAmount).toFixed(2)}
                                </td>
                              </tr>
                            ))}
                            <tr>
                              <td><strong>Total Employer Contribution</strong></td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.totalEmployerContributions).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.totalEmployerContributionsYearly).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td><strong>Total CTC A+C</strong></td>
                              <td style={{ textAlign: "right" }}>
                                <strong>
                                  {(
                                    parseFloat(state.data?.salaryOutput.grossSalary) +
                                    parseFloat(state.data?.salaryOutput.totalEmployerContributions)
                                  ).toFixed(2)}
                                </strong>
                              </td>
                              <td style={{ textAlign: "right" }}>
                                <strong>
                                  {(
                                    parseFloat(state.data?.salaryOutput.grossSalaryYearly) +
                                    parseFloat(state.data?.salaryOutput.totalEmployerContributionsYearly)
                                  ).toFixed(2)}
                                </strong>
                              </td>
                            </tr>
                            <tr>
                              <td>Total CTC</td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.costToCompany).toFixed(2)}
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {parseFloat(state.data?.salaryOutput.costToCompanyYearly).toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                  ) : (
                    <center>
                      <h3
                        style={{
                          position: "absolute",
                          left: "50%",
                          top: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        No Records
                      </h3>
                      <p style={{ color: "red", marginTop: "20px" }}>{errorMessage}</p>
                    </center>
                  )}
                </div>
              </div>
            </Form>
          }
        />
      </div>

      <div className="mb-3">
        <Widgets
          icon={<WidgetsIcon icon={<CgFileDocument />} title="Salary Details" />}
          button={
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "10px" }}>
              <WidgetsButton
                type="month"
                onClick={handleMonth}
                value={state.month}
                name={""}
                max={maxMonth}
              />
              {HasPermission("Salary details", "create") && (
                <WidgetsButton
                  type="button"
                  text="Download Payslip"
                  icon={<FiPlus className="btn-icon" />}
                  onClick={downloadBothPDF}
                />
              )}
            </div>
          }
          body={
            <div
              className="ag-theme-quartz custom-grid mt-3"
              style={{ position: "relative", height: "480px", width: "calc(100% - 10px)", zIndex: "0" }}
            >
              <AgGridReact
                rowData={Array.isArray(attendanceDbList) ? attendanceDbList : []}
                columnDefs={columns}
                omLayout="autoHeight"
                pagination={true}
                paginationPageSize={paginationPageSize}
                paginationPageSizeSelector={paginationPageSizeSelector}
              />
            </div>
          }
        />
      </div>

      {/* ✅ REMOVED: <ToastContainer /> — global toast handles everything now */}
    </div>
  );
};

export default SalaryDetails;